import React from 'react';
import { Col, Row } from 'reactstrap';
import { string } from '../../../../localization';
import { unitConverter } from '../../../../redux/actions/sizeHandler';
import { getUnit, checkIfMultiCanvas } from '../../../../redux/homeActions';
import { ProductCard } from '../ProductCard/ProductCard';
import './SizeSelection.scss';
import { Icons } from '../../../../utilities';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

const sizeList = props => {
  const {
    productSizes,
    unitSystem,
    iconFetchHandler,
    customSelectionHandler,
    sizeSelectionHandler,
    prevPageVisibilityHandler,
    previousPageHandler,
    dispatchers
  } = props;

  const sizeData = [];
  productSizes.default.sizes.forEach(size => {
    const name = `${unitConverter(size, 'width', unitSystem)} x ${unitConverter(
      size,
      'height',
      unitSystem
    )} ${getUnit(unitSystem)}`;
    const details = {
      id: size.id,
      name,
      productIconUrl: iconFetchHandler(size)
    };
    sizeData.push(details);
  });

  if (productSizes.custom.sizes) {
    const details = {
      id: string.CUSTOM_KEY,
      name: string.CUSTOM_KEY,
      productIconUrl: dispatchers.checkIfMultiCanvas()
        ? Icons.multiCanvasDesignerCustom
        : productSizes.custom.iconUrl
    };
    sizeData.push(details);
  }

  const sizeClicked = index => {
    if (index == productSizes.default.sizes.length) {
      customSelectionHandler();
    } else {
      sizeSelectionHandler(index);
    }
  };

  let medColumns = '3 ';
  let largeColumns = '2 ';
  if (sizeData.length <= 4) {
    medColumns = '3 ';
    largeColumns = '3 ';
  }
  if (sizeData.length <= 3) {
    medColumns = '4 ';
    largeColumns = '4 ';
  }
  if (sizeData.length <= 2) {
    medColumns = '6 ';
    largeColumns = '6 ';
  }

  return (
    <>
      {prevPageVisibilityHandler() ? (
        <button
          type='button'
          className='previousPageIcon'
          style={{ outline: 'none' }}
          onClick={previousPageHandler}
        >
          <img
            alt='close-button'
            src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAABBCAYAAAC5OQZxAAAABGdBTUEAALGPC/xhBQAAAdNJREFUaAXN2j1OwzAUAOA6ZYe9a48AYu1BEHfIzMycnAFxkK4IjsDKDgcg4b1gV4njJv55P7WUurErva8vcSQ/xWwUW13Xewj/CsdD0zSfSKnwQ6MhxhhzhNj32Fvcxmhi+r7fufiA+oLzgzjIZWaMcSjo30RBSxjxDMVg8MYWyVAsBi8dOygFww5KxbCCcjBsoFwMC6gEQw4qxZCCKDBkICoMCYgSUwyixhSBODDZIC5MFogTkwzixiSBJDDRIClMFEgSswqSxiyCNDBnQVqYIEgTMwNpYyYgi3mHHeUNToyb28S5gsB4jvr7sA2ymA/AXPsBJDEY21wSBkFXcDyHMgPjv13XPbZtO9Rt8McSDetDT3BZfgLBtlVVvWAGA3NsQxd3Dw0VNFw9cNluIVPf/l+H8R2Mnypc/jz1+amkZ1F3uKr8IJKoWfXDrrojInwYYmH8wPk8moEQoYkKgjRRZ0FaqEWQBmoVJI2KAkmiokFSqCSQBCoZxI3KAnGiskFcqCIQB6oYRI0iAVGiyEBUKFIQBYocVIpiAZWg2EC5KFZQDoodlIoSAaWgxECxKFHQGgrmZd9sQBC20L7PbULFM/RPmqIcBnfEaiCXKegn7w/9AUk21xvFj8GeAAAAAElFTkSuQmCC'
          />
        </button>
      ) : null}

      <div className='listContainer'>
        <Row>
          {sizeData.map((size, index) => (
            <Col
              xs='6'
              sm={medColumns}
              md={medColumns}
              lg={largeColumns}
              xl={largeColumns}
              key={size.id}
            >
              <ProductCard
                item={size}
                clickHandler={() => sizeClicked(index)}
                isWhiteBackground={() => false}
              />
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: bindActionCreators({ checkIfMultiCanvas }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(sizeList);
